module.exports = __webpack_public_path__ + "static/assets/f436ec45fe94644c3cfa43bc76c1ae12.png";